var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.79 24.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #6e5250;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #cc9eaf;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #7f93bb;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.55,
    y: 1.54,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.01,
    y: 1.54,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.63,
    y: 1.54,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.09,
    y: 1.54,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.55,
    y: 3.08,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.01,
    y: 3.08,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.63,
    y: 3.08,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.09,
    y: 3.08,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.17,
    y: 3.08,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.47,
    y: 3.08,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.55,
    y: 4.62,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.01,
    y: 4.62,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.63,
    y: 4.62,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.09,
    y: 4.62,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.17,
    y: 4.62,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.47,
    y: 4.62,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.93,
    y: 4.62,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.71,
    y: 4.62,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.55,
    y: 6.16,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.01,
    y: 6.16,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.63,
    y: 6.16,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.09,
    y: 6.16,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.17,
    y: 6.16,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.47,
    y: 6.16,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.93,
    y: 6.16,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.71,
    y: 6.16,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.55,
    y: 7.7,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.01,
    y: 7.7,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.63,
    y: 7.7,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.09,
    y: 7.7,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.17,
    y: 7.7,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.47,
    y: 7.7,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.55,
    y: 9.24,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.01,
    y: 9.24,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.63,
    y: 9.24,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.09,
    y: 9.24,
    width: 1.54,
    height: 1.54
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.55,
    y: 0,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 20.01,
    y: 0,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 24.63,
    y: 0,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 23.09,
    y: 0,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 18.47,
    y: 1.54,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.93,
    y: 3.08,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.39,
    y: 4.62,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.39,
    y: 6.16,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.93,
    y: 7.7,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 18.47,
    y: 9.24,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 26.17,
    y: 9.24,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 27.71,
    y: 7.7,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 29.25,
    y: 4.62,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 29.25,
    y: 6.16,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 27.71,
    y: 3.08,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 26.17,
    y: 1.54,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.55,
    y: 10.78,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 20.01,
    y: 10.78,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 24.63,
    y: 10.78,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 23.09,
    y: 10.78,
    width: 1.54,
    height: 1.54
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.62,
    y: 9.24,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.62,
    y: 10.78,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.62,
    y: 12.31,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.62,
    y: 13.85,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 17.7,
    y: 11.54,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.16,
    y: 11.54,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 13.08,
    y: 11.54,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.54,
    y: 11.54,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.55,
    y: 13.85,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.01,
    y: 13.85,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.63,
    y: 13.85,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.09,
    y: 13.85,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.55,
    y: 15.39,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.01,
    y: 15.39,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.63,
    y: 15.39,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.09,
    y: 15.39,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.17,
    y: 15.39,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.47,
    y: 15.39,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.55,
    y: 16.93,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.01,
    y: 16.93,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.63,
    y: 16.93,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.09,
    y: 16.93,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.17,
    y: 16.93,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.47,
    y: 16.93,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.93,
    y: 16.93,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.71,
    y: 16.93,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.55,
    y: 18.47,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.01,
    y: 18.47,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.63,
    y: 18.47,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.09,
    y: 18.47,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.17,
    y: 18.47,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.47,
    y: 18.47,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.93,
    y: 18.47,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.71,
    y: 18.47,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.55,
    y: 20.01,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.01,
    y: 20.01,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.63,
    y: 20.01,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.09,
    y: 20.01,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.17,
    y: 20.01,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.47,
    y: 20.01,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.55,
    y: 21.55,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.01,
    y: 21.55,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.63,
    y: 21.55,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.09,
    y: 21.55,
    width: 1.54,
    height: 1.54
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.55,
    y: 12.31,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 20.01,
    y: 12.31,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 24.63,
    y: 12.31,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 23.09,
    y: 12.31,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 18.47,
    y: 13.85,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.93,
    y: 15.39,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.39,
    y: 16.93,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.39,
    y: 18.47,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 16.93,
    y: 20.01,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 18.47,
    y: 21.55,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 26.17,
    y: 21.55,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 27.71,
    y: 20.01,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 29.25,
    y: 16.93,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 29.25,
    y: 18.47,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 27.71,
    y: 15.39,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 26.17,
    y: 13.85,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.55,
    y: 23.09,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 20.01,
    y: 23.09,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 24.63,
    y: 23.09,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 23.09,
    y: 23.09,
    width: 1.54,
    height: 1.54
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.16,
    y: 13.85,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.62,
    y: 13.85,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.24,
    y: 13.85,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.7,
    y: 13.85,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.16,
    y: 15.39,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.62,
    y: 15.39,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.24,
    y: 15.39,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.7,
    y: 15.39,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.78,
    y: 15.39,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.08,
    y: 15.39,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.16,
    y: 16.93,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.62,
    y: 16.93,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.24,
    y: 16.93,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.7,
    y: 16.93,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.78,
    y: 16.93,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.08,
    y: 16.93,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.54,
    y: 16.93,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.31,
    y: 16.93,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.16,
    y: 18.47,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.62,
    y: 18.47,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.24,
    y: 18.47,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.7,
    y: 18.47,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.78,
    y: 18.47,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.08,
    y: 18.47,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.54,
    y: 18.47,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.31,
    y: 18.47,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.16,
    y: 20.01,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.62,
    y: 20.01,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.24,
    y: 20.01,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.7,
    y: 20.01,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.78,
    y: 20.01,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.08,
    y: 20.01,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.16,
    y: 21.55,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.62,
    y: 21.55,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.24,
    y: 21.55,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.7,
    y: 21.55,
    width: 1.54,
    height: 1.54
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 6.16,
    y: 12.31,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 4.62,
    y: 12.31,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9.24,
    y: 12.31,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 7.7,
    y: 12.31,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.08,
    y: 13.85,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1.54,
    y: 15.39,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    y: 16.93,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    y: 18.47,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1.54,
    y: 20.01,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.08,
    y: 21.55,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 10.78,
    y: 21.55,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 12.31,
    y: 20.01,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 13.85,
    y: 16.93,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 13.85,
    y: 18.47,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 12.31,
    y: 15.39,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 10.78,
    y: 13.85,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 6.16,
    y: 23.09,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 4.62,
    y: 23.09,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9.24,
    y: 23.09,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 7.7,
    y: 23.09,
    width: 1.54,
    height: 1.54
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.16,
    y: 1.54,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.62,
    y: 1.54,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.24,
    y: 1.54,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.7,
    y: 1.54,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.16,
    y: 3.08,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.62,
    y: 3.08,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.24,
    y: 3.08,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.7,
    y: 3.08,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.78,
    y: 3.08,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.08,
    y: 3.08,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.16,
    y: 4.62,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.62,
    y: 4.62,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.24,
    y: 4.62,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.7,
    y: 4.62,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.78,
    y: 4.62,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.08,
    y: 4.62,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.54,
    y: 4.62,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.31,
    y: 4.62,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.16,
    y: 6.16,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.62,
    y: 6.16,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.24,
    y: 6.16,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.7,
    y: 6.16,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.78,
    y: 6.16,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.08,
    y: 6.16,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.54,
    y: 6.16,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.31,
    y: 6.16,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.16,
    y: 7.7,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.62,
    y: 7.7,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.24,
    y: 7.7,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.7,
    y: 7.7,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.78,
    y: 7.7,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.08,
    y: 7.7,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.16,
    y: 9.24,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.62,
    y: 9.24,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.24,
    y: 9.24,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.7,
    y: 9.24,
    width: 1.54,
    height: 1.54
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 6.16,
    y: 0,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 4.62,
    y: 0,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9.24,
    y: 0,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 7.7,
    y: 0,
    width: 1.54,
    height: 1.54
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.08,
    y: 1.54,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1.54,
    y: 3.08,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    y: 4.62,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    y: 6.16,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1.54,
    y: 7.7,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.08,
    y: 9.24,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 10.78,
    y: 9.24,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 12.31,
    y: 7.7,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 13.85,
    y: 4.62,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 13.85,
    y: 6.16,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 12.31,
    y: 3.08,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 10.78,
    y: 1.54,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 6.16,
    y: 10.78,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 4.62,
    y: 10.78,
    width: 1.54,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9.24,
    y: 10.78,
    width: 1.54,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 7.7,
    y: 10.78,
    width: 1.54,
    height: 1.54
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower2);
export default __webpack_public_path__ + "static/media/flower_2.a07eee5205d89b5f63af1cd922854d04.svg";
export { ForwardRef as ReactComponent };